<template>
    <modal :show.sync="show_modal" :hide-footer="true">
        <div class="table-simple-modal" v-if="approval && approval.appr_req_value">
            <b-table-simple responsive bordered>
                <b-tbody>
                    <b-tr>
                        <b-th class="bg-dark text-white py-2" width="150px">Lead ID</b-th>
                        <b-td class="bg-white py-2">{{ approval.appr_req_value.lead_id }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="bg-dark text-white py-2" width="150px">Lead Contact No.</b-th>
                        <b-td class="bg-white py-2">{{ approval.appr_req_value.contact_no }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="bg-dark text-white py-2" width="150px">Lead Email</b-th>
                        <b-td class="bg-white py-2">{{ approval.appr_req_value.email }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="bg-dark text-white py-2" width="150px">Lead Income</b-th>
                        <b-td class="bg-white py-2">{{ approval.appr_req_value.income | moneyFormatter }}</b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>

            <b-col cols="12" class="px-4 py-3">
                <h3>Uploaded Documents</h3>
            </b-col>

            <b-table-simple responsive borderless>
                <b-thead>
                    <b-tr>
                        <b-th class="bg-dark text-white py-2" style="min-width: 100px">Document ID</b-th>
                        <b-th class="bg-dark text-white py-2" style="min-width: 250px">Original Filename</b-th>
                        <b-th class="bg-dark text-white py-2" style="min-width: 150px">Category</b-th>
                        <b-th class="bg-dark text-white py-2" style="min-width: 150px">Updated By</b-th>
                        <b-th class="bg-dark text-white py-2" style="min-width: 150px">Updated Date</b-th>
                        <b-th class="bg-dark text-white py-2" style="min-width: 250px">Remarks</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody v-for="attachment in attachments" :key="attachment.attachment_id">
                    <b-tr>
                        <b-td>{{ attachment.attachment_id }}</b-td>
                        <b-td>
                            <a href=""  
                                class="text-primary font-weight-bold"
                                @click.prevent="$refs.preview_modal.preview(attachment.url, attachment.original_filename)">
                                {{ attachment.original_filename }}
                            </a>
                        </b-td>
                        <b-td>{{ attachment.attachment_category}}</b-td>
                        <b-td>{{ attachment.created_by_detail.name }}</b-td>
                        <b-td>{{ attachment.updated_at | dateTimeFormatString }}</b-td>
                        <b-td>{{ attachment.remark }}</b-td>
                        <b-td min-width="60px" align="center">
                            <div slot-scope="{row}" class="table-actions">
                                <a href="javascript:void(0)" @click.prevent="download(attachment)" class="table-action" data-toggle="tooltip" data-original-title="Download">
                                    <i class="fa fa-download fa-lg text-primary"></i>
                                </a>
                            </div>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <PreviewModal ref="preview_modal"></PreviewModal>
        </div>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import {
    notifyFunctionMixin,
    helperFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'
import Documents from '@/components/Documents'
import PreviewModal  from '@/components/Modal/PreviewModal'

export default {
    props: ['approval'],
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    components: {
        Modal,
        PreviewModal
    },
    data() {
        return {
            show_modal: false,
            remark: '',
            services: services,
            attachments: null,
        }
    },
    watch: {
        approval(newVal) {
            if(newVal){
                this.getAttachments()
            }
        }
    },
    methods: {
        toggleView() {
            this.show_modal = !this.show_modal;
        },
        getAttachments() {
            axios.get(services.lead + 'lead/' + this.approval.appr_req_value.lead_id + '/attachments', {headers: getHeader()})
                .then(res => {
                    this.attachments = res.data.data;
                })
                .catch(e=>{
                    this.errorFunction(e)
                })
        },
        download(row){
            axios.get(
                services.lead + 'lead/' + this.approval.appr_req_value.lead_id +'/attachments/' +row.attachment_id+'/download',
                {
                    headers: getHeader(),
                    responseType: 'blob'
                }
            )
            .then(response => {
                this.createDownloadFileLink(response.data, row.original_filename)
            })
            .catch(e => {
                this.errorFunction(e)
            });
        },
    },
}
</script>